import React from "react";
import { MapPin } from "lucide-react";

// Shared status/priority visuals + a single job-card row, used by MobileHome
// (tech-perspective Overview/All Jobs tabs) and HistoryTab.

export const STATUS_SOLID = {
  Unassigned: "bg-slate-600 text-white",
  Scheduled: "bg-[#2563EB] text-white",
  Dispatched: "bg-[#D97706] text-white",
  "En Route": "bg-[#D97706] text-white",
  "On Site": "bg-[#4F46E5] text-white",
  "In Progress": "bg-[#0EA5E9] text-white",
  Completed: "bg-[#059669] text-white",
  Canceled: "bg-[#E11D48] text-white",
};

export const PRIORITY_DOT = { Urgent: "#E11D48", High: "#F59E0B", Normal: "#3B82F6", Low: "#94A3B8" };

export function fmtTime(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? "—" : d.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });
}

export function fmtDateTime(iso) {
  if (!iso) return "TBD";
  const d = new Date(iso);
  return Number.isNaN(d.getTime())
    ? "TBD"
    : d.toLocaleString([], { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });
}

// Human-friendly day header for a job's scheduled date.
export function dayLabel(iso) {
  if (!iso) return "Unscheduled";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "Unscheduled";
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const that = new Date(d);
  that.setHours(0, 0, 0, 0);
  const diff = Math.round((that - today) / 86400000);
  if (diff === 0) return "Today";
  if (diff === 1) return "Tomorrow";
  if (diff === -1) return "Yesterday";
  return d.toLocaleDateString([], { weekday: "long", month: "short", day: "numeric" });
}

export function MobileJobCard({ job, onOpen, showDate }) {
  const solid = STATUS_SOLID[job.status] || "bg-slate-600 text-white";
  const jobNum = (job.id || "").replace(/^J[-\s]?/i, "");
  return (
    <button
      onClick={onOpen}
      data-testid={`job-card-${job.id}`}
      className="w-full text-left bg-white rounded-xl p-4 mb-3 mx-4 max-w-[calc(100%-2rem)] active:scale-[0.98] transition-transform flex gap-3 border border-slate-200"
    >
      <div className="flex flex-col min-w-[104px] pt-0.5">
        <span className="text-[15px] font-bold text-[#173B89] leading-tight">
          {showDate ? fmtDateTime(job.start) : fmtTime(job.start)}
        </span>
        <span className="text-[11px] text-slate-400 mt-1">Job #{jobNum || job.id}</span>
        <span className="mt-2 self-start px-3 py-1 rounded-full text-[11px] font-semibold bg-slate-100 text-slate-600 max-w-[104px] truncate">
          {job.type || "Job-type"}
        </span>
      </div>
      <div className="flex-1 min-w-0 border-l border-slate-200 pl-3">
        <div className="text-[16px] font-bold text-[#173B89] leading-tight truncate">{job.customer}</div>
        <div className="flex items-center gap-1.5 text-[12px] text-slate-400 mt-1">
          <MapPin className="h-3.5 w-3.5 shrink-0" />
          <span className="truncate">{job.address}{job.city ? `, ${job.city}` : ""}</span>
        </div>
        <div className="flex items-center gap-2 mt-3">
          <span className="shrink-0 inline-flex items-center gap-1.5 text-[11px] font-medium text-slate-400">
            <span className="h-2 w-2 rounded-full" style={{ background: PRIORITY_DOT[job.priority] || "#3B82F6" }} />
            {job.priority || "Priority"}
          </span>
          <span className={`ml-auto px-3 py-1 rounded-full text-[11px] font-bold shrink-0 ${solid}`}>
            {job.status}
          </span>
        </div>
      </div>
    </button>
  );
}

export default MobileJobCard;
